module.exports = __webpack_public_path__ + "static/provalindo-febriman-siregar-579d0d913d5ebae472521ba09936982a.png";